import React from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface ContextMenuState {
    mouseX: number;
    mouseY: number;
}

interface ClientsContextMenuProps {
    contextMenu: ContextMenuState | null;
    canView: boolean;
    canEdit: boolean;
    canDelete: boolean;
    onClose: () => void;
    onCreate: () => void;
    onView: () => void;
    onEdit: () => void;
    onDelete: () => Promise<void>;
}

const ClientsContextMenu: React.FC<ClientsContextMenuProps> = ({
    contextMenu,
    canView,
    canEdit,
    canDelete,
    onClose,
    onCreate,
    onView,
    onEdit,
    onDelete,
}) => {
    return (
        <Menu
            open={contextMenu !== null}
            onClose={onClose}
            anchorReference='anchorPosition'
            anchorPosition={
                contextMenu !== null
                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                    : undefined
            }
        >
            <MenuItem onClick={onCreate}>
                <ListItemIcon>
                    <AddIcon />
                </ListItemIcon>
                <ListItemText primary='Crear cliente' />
            </MenuItem>

            <MenuItem
                disabled={!canView}
                onClick={onView}
            >
                <ListItemIcon>
                    <VisibilityOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary='Ver' />
            </MenuItem>

            <MenuItem disabled={!canEdit} onClick={onEdit}>
                <ListItemIcon>
                    <EditOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary='Editar' />
            </MenuItem>

            <MenuItem
                disabled={!canDelete}
                onClick={onDelete}
            >
                <ListItemIcon>
                    <DeleteOutlineIcon />
                </ListItemIcon>
                <ListItemText primary='Eliminar' />
            </MenuItem>
        </Menu>
    );
};

export { ClientsContextMenu };
